import { render, staticRenderFns } from "./AegSteps.vue?vue&type=template&id=1b45549f"
import script from "./AegSteps.vue?vue&type=script&lang=js"
export * from "./AegSteps.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports